import { NvTableCellProps } from 'shared/components/nv-table';
import { MentoringProgramGuide } from 'redux/schemas/models/mentoring-program-guides';

export enum ColumnID {
  APPEARS_IN = 'appears_in',
  TITLE = 'title',
  AUDIENCE = 'audience',
  OPTIONS = 'options',
}

export type CellProps = NvTableCellProps<MentoringProgramGuide>;
